import { features } from "../../config/appVariant";
import { addImage } from "../../redux/slices/BulkConversion";

/**
 * Queue an image in the bulk-converter Redux slice.
 * No-op on EmbroideryTrace — bulk convert is SvgTrace-only.
 */
export function queueUploadImage(dispatch, imageData) {
  if (!features.svgEditor) return;
  dispatch(addImage(imageData));
}
